<template>
    <div>
        <v-card>
            <v-card-title class="pb-0 headline">Filtro de empleados</v-card-title>
            <v-card-text class="pt-0">
                <v-flex xs12 sm12>
                    <v-alert
                        v-model="showErrorDataLoadedAlert"
                        type="error"
                        dismissible
                        transition="scale-transition"
                        dark
                    >
                        No se han podido cargar todos los datos necesarios para este filtro.
                        <br />
                        Intente cargar el filtro nuevamente.
                    </v-alert>

                    <template>
                        <v-container style="max-width: 500px" class="pa-1">
                            <v-autocomplete
                                v-model="selectedCampos"
                                class="pt-0"
                                :items="inputs"
                                item-value="text"
                                return-object
                                hide-selected
                                placeholder="Selecciones los campos para filtrar..."
                                multiple
                                persistent-hint
                                deletable-chips
                                small-chips
                                dense
                                clearable
                                tags
                                ref="selectedCamposRef"
                            >
                            </v-autocomplete>

                            <v-divider></v-divider>

                            <v-flex class="my-1" align="center">
                                <v-layout>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 black--text">
                                            Filtros: {{ selectedCampos.length }}
                                        </strong>
                                    </v-fade-transition>
                                    <v-fade-transition leave-absolute>
                                        <strong class="mx-4 my-1 green--text"> Activos: {{ activeFilters }} </strong>
                                    </v-fade-transition>

                                    <v-spacer></v-spacer>

                                    <v-btn color="success" small class="my-0" @click="applyFilter()">
                                        Aplicar
                                    </v-btn>
                                </v-layout>
                            </v-flex>

                            <v-divider class="mb-4"></v-divider>

                            <v-card v-if="selectedCampos.length > 0">
                                <v-list>
                                    <v-slide-y-transition class="py-0" group tag="v-list">
                                        <template v-for="(campo, i) in selectedCampos">
                                            <v-divider v-if="i !== 0" :key="`${i}-divider`" class="pb-0"></v-divider>
                                            <v-list-tile :key="campo.id">
                                                <v-list-tile-action>
                                                    <v-checkbox
                                                        v-model="campo.activo"
                                                        :disabled="selectedCampos[i].value.length === 0"
                                                        color="info"
                                                        class="mt-3"
                                                    >
                                                    </v-checkbox>
                                                </v-list-tile-action>

                                                <v-list-tile-content>
                                                    <template v-if="campo.text === 'Campus'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="CAMPUS"
                                                            label="Campus"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Puesto'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="PUESTOS"
                                                            label="Puesto"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Sección'">
                                                        <v-select
                                                            v-if="inputs[6].value !== ''"
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="
                                                                SECCIONES.filter(el => el.campus_id === inputs[6].value)
                                                            "
                                                            label="Sección"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                        <v-card-text class="mt-3" v-else>
                                                            Seleccione el campus
                                                        </v-card-text>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Departamento'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="DEPARTAMENTOS"
                                                            label="Departamento"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Estado civil'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="ESTADOS_CIVIL"
                                                            label="Estado civil"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Tipo de contrato'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { text: 'COLEGIO_IMSS', value: 1 },
                                                                { text: 'COLEGIO_HONORARIOS', value: 2 },
                                                                { text: 'OUTSOURCING_IMSS', value: 3 },
                                                                { text: 'OUTSOURCING_HONORARIOS', value: 4 }
                                                            ]"
                                                            label="Tipo de contrato"
                                                            item-text="text"
                                                            item-value="value"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Fecha de nacimiento'">
                                                        <v-menu
                                                            ref="menuFechaNacimiento"
                                                            v-model="menuFechaNacimiento"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            lazy
                                                            transition="scale-transition"
                                                            offset-y
                                                            full-width
                                                            min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    v-model="computedFechaNacimientoFormatted"
                                                                    label="Fecha nacimiento"
                                                                    readonly
                                                                    v-on="on"
                                                                    class="mt-3"
                                                                    @blur="
                                                                        dateFechaNacimiento = parseDate(
                                                                            selectedCampos[i].value
                                                                        )
                                                                    "
                                                                >
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="dateFechaNacimiento"
                                                                no-title
                                                                scrollable
                                                                @input="menuFechaNacimiento = false"
                                                            >
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Fecha de ingreso'">
                                                        <v-menu
                                                            ref="menuFechaIngreso"
                                                            v-model="menuFechaIngreso"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            lazy
                                                            transition="scale-transition"
                                                            offset-y
                                                            full-width
                                                            min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    v-model="computedFechaIngresoFormatted"
                                                                    label="Fecha ingreso"
                                                                    readonly
                                                                    v-on="on"
                                                                    class="mt-3"
                                                                    @blur="
                                                                        dateFechaIngreso = parseDate(
                                                                            selectedCampos[i].value
                                                                        )
                                                                    "
                                                                >
                                                                </v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="dateFechaIngreso"
                                                                no-title
                                                                scrollable
                                                                @input="menuFechaIngreso = false"
                                                            >
                                                            </v-date-picker>
                                                        </v-menu>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Sexo'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="SEXOS"
                                                            label="Sexo"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Escolaridad'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="ESCOLARIDADES"
                                                            label="Escolaridad"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Titulo'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="TITULOS"
                                                            label="Título"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Estado contrato'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { nombre: 'Activo', value: 1 },
                                                                { nombre: 'Baja', value: 2 },
                                                                { nombre: 'Pendiente', value: 3 },
                                                                { nombre: 'Rechazado', value: 4 }
                                                            ]"
                                                            :label="campo.text"
                                                            item-text="nombre"
                                                            item-value="value"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Tipo de pago'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { nombre: 'Fijo', value: 1 },
                                                                { nombre: 'Por horas', value: 2 }
                                                            ]"
                                                            :label="campo.text"
                                                            item-text="nombre"
                                                            item-value="value"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else-if="campo.text === 'Asesor'">
                                                        <v-select
                                                            v-model="inputs[campo.id - 1].value"
                                                            :items="[
                                                                { nombre: 'Si', value: 1 },
                                                                { nombre: 'No', value: 0 }
                                                            ]"
                                                            :label="campo.text"
                                                            item-text="nombre"
                                                            item-value="value"
                                                            class="mt-3"
                                                        >
                                                        </v-select>
                                                    </template>

                                                    <template v-else>
                                                        <v-text-field
                                                            v-model="selectedCampos[i].value"
                                                            :label="campo.text"
                                                            autofocus
                                                            class="mt-3"
                                                        >
                                                        </v-text-field>
                                                    </template>
                                                </v-list-tile-content>

                                                <v-spacer></v-spacer>

                                                <v-scroll-x-transition>
                                                    <v-icon v-if="campo.activo" color="success">
                                                        fa-check
                                                    </v-icon>
                                                </v-scroll-x-transition>
                                            </v-list-tile>
                                        </template>
                                    </v-slide-y-transition>
                                </v-list>
                            </v-card>
                        </v-container>
                    </template>
                </v-flex>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Util from "@/util"
import { mapGetters } from "vuex"

export default {
    name: "CustomFilterEmpleado",
    props: {
        internalState: { type: Object, default: null }
    },
    data: () => ({
        inputs: Util.EmpleadoCampos(),
        selectedCampos: [],

        //fecha nacimiento
        menuFechaNacimiento: false,
        dateFechaNacimiento: new Date().toISOString().substr(0, 10),

        //fecha ingreso
        menuFechaIngreso: false,
        dateFechaIngreso: new Date().toISOString().substr(0, 10),

        //saber si se cargaron todos los datos necesarios para seleccionar
        showErrorDataLoadedAlert: false
    }),
    methods: {
        applyFilter() {
            let customFilter = ""
            this.selectedCampos.forEach(campo => {
                if (campo.activo) {
                    if (campo.attribute === "fecha_ingreso" || campo.attribute === "fecha_nacido") {
                        customFilter = customFilter + `${campo.attribute}=${this.parseDate(campo.value)}&`
                    } else {
                        customFilter = customFilter + `${campo.attribute}=${campo.value}&`
                    }
                }
            })
            customFilter = customFilter.slice(0, -1)
            return this.$emit("applyFilter", {
                customFilter: customFilter,
                activeFilters: this.activeFilters,
                internalState: {
                    inputs: this.inputs,
                    selectedCampos: this.selectedCampos
                }
            })
        },

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        }
    },

    computed: {
        activeFilters() {
            return this.selectedCampos.filter(campo => campo.activo).length
        },

        ...mapGetters([
            "CAMPUS",
            "PUESTOS",
            "SECCIONES",
            "DEPARTAMENTOS",
            "ESTADOS_CIVIL",
            "SEXOS",
            "ESCOLARIDADES",
            "TITULOS"
        ]),

        computedFechaIngresoFormatted() {
            this.inputs[15].value = this.formatDate(this.dateFechaIngreso)
            return this.formatDate(this.dateFechaIngreso)
        },

        computedFechaNacimientoFormatted() {
            this.inputs[4].value = this.formatDate(this.dateFechaNacimiento)
            return this.formatDate(this.dateFechaNacimiento)
        }
    },

    watch: {
        selectedCampos(val) {
            setTimeout(() => {
                this.$refs.selectedCamposRef.isMenuActive = false
            }, 50)
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_CAMPUS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SECCIONES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_DEPARTAMENTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_PUESTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_ESTADOS_CIVIL").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SEXOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_ESCOLARIDADES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_TITULOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.internalState) {
            this.selectedCampos = this.internalState.selectedCampos
            this.inputs = this.internalState.inputs
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
